/** @format */

/**
 * Lightweight security-event logger for client-side monitoring.
 * - Captures CSP violations via the browser's securitypolicyviolation event.
 * - Redacts any object key that looks like a credential before storing.
 * - In DEV mode, every event is also printed to the console.
 * - getSecurityEvents() returns a snapshot for the dev dashboard.
 */

const SENSITIVE_PATTERNS = [
  'token',
  'password',
  'secret',
  'apikey',
  'refreshtoken',
  'authorization',
  'credential',
]

const MAX_EVENTS = 200

const events: any[] = []

function redactValue(key: string) {
  return SENSITIVE_PATTERNS.some((pattern) =>
    key.toLowerCase().includes(pattern)
  )
}

function redact(obj: any) {
  if (!obj || typeof obj !== 'object') return obj

  const out: Record<string, any> = {}
  for (const key of Object.keys(obj)) {
    out[key] = redactValue(key) ? '[REDACTED]' : obj[key]
  }
  return out
}

export function logSecurityEvent(type: string, details = {}) {
  const event = {
    type,
    timestamp: new Date().toISOString(),
    details: redact(details),
  }

  events.push(event)
  if (events.length > MAX_EVENTS) events.shift()

  if (import.meta.env.DEV) {
     
    console.warn('[SecurityEvent]', event)
  }
}

export function getSecurityEvents() {
  return [...events]
}

/**
 * Call once at app startup.  Listens for Content-Security-Policy violations
 * and logs them as security events.
 */
export function setupCSPViolationListener() {
  document.addEventListener('securitypolicyviolation', (e) => {
    logSecurityEvent('csp-violation', {
      directive: e.violatedDirective,
      blockedURI: e.blockedURI,
      source: e.sourceFile,
      policy: e.originalPolicy,
    })
  })
}
